<template>
  <dt class="fr-text--sm fr-my-0 fr-text--bold">
    <slot></slot>
  </dt>
</template>

<script setup lang="ts">
</script>
